'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselSection = exports.CLASS_INITIALIZED = exports.PREV_SELECTOR = exports.NEXT_SELECTOR = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

var _ShopifySection2 = require('./../../sections/ShopifySection');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Carousel Section
 *    Superclass for any carousel section you build, provides nice defaults that
 *    can be provided as data attributes from the wrapped container.
 *
 *  Version:
 *    1.0.0 - 2020/05/16
 */
var NEXT_SELECTOR = exports.NEXT_SELECTOR = '[data-slick-arrow-next]';
var PREV_SELECTOR = exports.PREV_SELECTOR = '[data-slick-arrow-prev]';
var CLASS_INITIALIZED = exports.CLASS_INITIALIZED = 'slick-initialized';

var CarouselSection = exports.CarouselSection = function (_ShopifySection) {
  (0, _inherits3.default)(CarouselSection, _ShopifySection);

  function CarouselSection(container) {
    (0, _classCallCheck3.default)(this, CarouselSection);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CarouselSection.__proto__ || Object.getPrototypeOf(CarouselSection)).call(this, container));

    _this.options = {
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      swipeToSlide: true,
      cssEase: _this.container.css('animation-timing-function') || 'ease-in-out',
      touchThreshold: 200
    };
    return _this;
  }

  (0, _createClass3.default)(CarouselSection, [{
    key: 'initCarousel',
    value: function initCarousel(carouselElement, moreOverrides) {
      moreOverrides = moreOverrides || {};
      var slick = carouselElement.slick(Object.assign({}, this.options, this.optionOverrides(), moreOverrides));

      return slick;
    }
  }, {
    key: 'optionOverrides',
    value: function optionOverrides() {
      return {};
    }
  }]);
  return CarouselSection;
}(_ShopifySection2.ShopifySection);